import { render, staticRenderFns } from "./msw-help-content.vue?vue&type=template&id=497a352e&"
import script from "./msw-help-content.vue?vue&type=script&lang=ts&"
export * from "./msw-help-content.vue?vue&type=script&lang=ts&"
import style0 from "./msw-help-content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports